<template lang="pug">

    .field(v-bind:class='{ required: isRequired, error: $slots.error }')

        label(v-bind:for="fieldId") {{ label }}

        select.ui.clearable.search.selection.dropdown(
            ref='dropdownEl'
            v-bind:id='fieldId'
            v-bind:disabled='isDisabled'
        )
            option(v-bind:value="undefined" v-if="withEmptyOption")
            option(
                v-for="option in options"
                v-bind:value="option[optionValue]"
            ) {{ option[optionLabel] }}

        slot

</template>

<script>

    //noinspection ReservedWordAsName,JSUnusedGlobalSymbols
    export default {

        data() {
            return {
                fieldId: this.$rndId()
            }
        },

        mounted() {
            this._initDropdown()
        },

        watch: {
            value(newVal) {
                const el = this.$refs.dropdownEl
                if (!el) return
                const $dd = $(el).parent('.ui.dropdown')
                if (!$dd.length || !$dd.data('module-dropdown')) return
                const newStr = newVal != null ? String(newVal) : ''
                const currentStr = String($dd.dropdown('get value') || '')
                if (newStr === currentStr) return
                if (newVal != null && newVal !== undefined) {
                    $dd.dropdown('set selected', String(newVal))
                } else {
                    $dd.dropdown('clear')
                }
            }
        },

        methods: {
            _initDropdown() {
                const el = this.$refs.dropdownEl
                if (!el) return
                // Prüfen ob Fomantic bereits auf dem Container-Div initialisiert ist.
                // (Fomantic wickelt <select> in ein '.ui.dropdown' Container-Div ein
                // und speichert Instanzdaten dort — nicht auf dem <select> selbst.)
                const $container = $(el).parent('.ui.dropdown')
                if ($container.length && $container.data('module-dropdown')) return
                $(el).dropdown({
                    onChange: (value) => {
                        if (value == null || value === '') {
                            if (this.value != null) this.$emit('input', undefined)
                        } else {
                            const opt = this.options.find(o => String(o[this.optionValue]) === String(value))
                            const newVal = opt ? opt[this.optionValue] : value || undefined
                            if (newVal !== this.value) this.$emit('input', newVal)
                        }
                    }
                })
                if (this.value != null && this.value !== undefined) {
                    // Nach der Initialisierung: set selected auf dem Container-Div aufrufen
                    const $dd = $(el).parent('.ui.dropdown')
                    if ($dd.length) {
                        $dd.dropdown('set selected', String(this.value))
                    }
                }
            }
        },

        props: {
            value: {
                required: true
            },
            label: {
                type: String,
                required: true
            },
            isDisabled: {
                type: Boolean,
                default: false
            },
            isRequired: {
                type: Boolean,
                default: false
            },
            options: {
                type: Array,
                required: true
            },
            optionValue: {
                type: String,
                default: 'id'
            },
            optionLabel: {
                type: String,
                default: 'name'
            },
            withEmptyOption: {
                type: Boolean,
                default: true
            }
        }
    }

</script>
